module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_feijoada.7c740a1f.png";